import { render, staticRenderFns } from "./JC.vue?vue&type=template&id=55984776&scoped=true&"
import script from "./JC.vue?vue&type=script&lang=js&"
export * from "./JC.vue?vue&type=script&lang=js&"
import style0 from "./JC.vue?vue&type=style&index=0&id=55984776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55984776",
  null
  
)

export default component.exports